<template>
  <v-card>
    <v-card-title class="d-flex align-center">
      <span>
        {{ $bct('Confirming verification') }}
      </span>

      <v-spacer />

      <v-btn
        @click="$emit('cancel')"
        data-testid="close-button"
        icon="close"
        variant="text"
      />
    </v-card-title>

    <v-divider />

    <v-card-text class="pt-6 pb-6">
      <div class="mb-4">
        {{
          $bct(subsidyProgram?.coc_confirmation_custom_text || 'You are verifying the following')
        }}
      </div>

      <div
        v-if="enrollment"
        class="mb-4 bg-super-light-blue pa-3"
      >
        <div class="fs-18 fw-600 mb-1">
          {{ enrollment.name }}
        </div>
        <div class="c-light-black">{{ $bct('DOB') }}: {{ enrollment.meta?.child?.dob }}</div>
      </div>

      <ul
        v-if="tagsToVerify.length > 0"
        class="pl-4"
      >
        <li
          v-for="tag in tagsToVerify"
          :key="tag"
        >
          {{ $bct(tag) }}
        </li>
      </ul>
    </v-card-text>

    <v-divider />

    <v-card-actions class="d-flex justify-center pa-4">
      <v-btn
        @click="$emit('cancel')"
        class="me-3"
        color="red"
        variant="outlined"
      >
        {{ $bct('Cancel') }}
      </v-btn>

      <v-btn
        @click="$emit('confirm')"
        color="primary"
        variant="flat"
      >
        {{ $bct('Verify') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  enrollment: {
    type: Object,
    default: null,
  },
  subsidyProgram: {
    type: Object,
    default: null,
  },
  tagsToVerify: {
    type: Array,
    default: () => [],
  },
});

defineEmits(['cancel', 'confirm']);
</script>
